import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';

import localStorage from 'utils/localStorage'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  avatarSm: {
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, onClose, open, ...rest } = props;

  const classes = useStyles();

  const profile = localStorage.getUserInfo();
  const fullInfo = localStorage.getFullInfo();
  return (
    <div
        style={{cursor: 'pointer'}}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={open ? classes.avatar : classes.avatarSm}
        component={RouterLink}
        src={(profile && profile.avatar) || null}
        to={`/employees/${encodeURIComponent((profile && profile.displayName) || '')}/${(fullInfo && fullInfo.nameid || '')}/information`}
        onClick={onClose}
      />

      {open && <RouterLink to={`/employees/${encodeURIComponent((profile && profile.displayName) || '')}/${(fullInfo && fullInfo.nameid || '')}/information`} onClick={onClose}>
        <Typography
          className={classes.name}
          variant="h4"
        >
          {(profile && profile.displayName) || ''}
        </Typography>
      </RouterLink>}
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
